import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { Service } from '../service';
import { map } from 'rxjs/operators';
export interface UserPermissions {
  [key: string]: boolean;
}
@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  private permissionsSubject = new BehaviorSubject<UserPermissions>({});
  public permissions$: Observable<UserPermissions> = this.permissionsSubject.asObservable();
  constructor(private apiService: Service) {}
  loadUserPermissions(): Observable<UserPermissions> {
    return this.apiService.checkUserPermission().pipe(
      map((data: any) => {
        const permissions: UserPermissions = {};

        data.forEach((item: any) => {
          if (item.screenName && item.hasOwnProperty('permission')) {
            permissions[item.screenName] = item.permission || false;
          }
        });

        this.permissionsSubject.next(permissions);
        return permissions;
      })
    );
  }
  // Check if user has permission for a specific screen/component
  checkUserPermission(screenName: string): boolean {
    const permissions = this.permissionsSubject.getValue();
    if(permissions[screenName] === undefined) {
      this.loadUserPermissions().subscribe();
    }
    return permissions[screenName] || false;
  }

  getUserPermission(screenName: string): Observable<boolean> {
    const permissions = this.permissionsSubject.getValue();

    if (permissions[screenName] !== undefined) {
      return of(permissions[screenName]);
    }

    return this.loadUserPermissions().pipe(
      map((loadedPermissions: UserPermissions) => loadedPermissions[screenName] || false)
    );
  }
  // Get all permissions
  getAllPermissions(): UserPermissions {
    return this.permissionsSubject.getValue();
  }
  // Clear permissions on logout
  clearPermissions(): void {
    this.permissionsSubject.next({});
  }
}